<script setup lang="ts">
import type { Organization } from "@Modules/teams/Data/Models/OrganizationModel.ts";
import useTranslation from "@Composables/useTranslation";
import SettingsTopBar from "@Modules/teams/components/SettingsTopBar.vue";
import OrgSettingsContent from "@Modules/teams/components/OrgSettingsContent.vue";
import OrgNameForm from "@Modules/teams/components/OrgNameForm.vue";
import IconProfileForm from "@Modules/shared/Components/IconProfileForm.vue";

//
// Setup
const { __ } = useTranslation();

//
// Props
defineProps<{
	organization: Organization
	errors: Record<string, string>
	loading: boolean
}>();

//
// Emit
const emit = defineEmits<{
	(e: "update-icon", picture: File): void
	(e: "update-name", name: string): void
}>();
</script>

<template>
  <div class="org-profile-settings">
    <SettingsTopBar :title="__('organization_profile_settings.title')" />

    <OrgSettingsContent :title="__('organization_profile_settings.icon_section_title')">
      <IconProfileForm
        :user-name="organization.name"
        :profile-src="organization.photo_url"
        :errors="errors"
        :loading="loading"
        @submit="(picture) => emit('update-icon', picture)"
      />
    </OrgSettingsContent>

    <OrgSettingsContent :title="__('organization_profile_settings.general_info_section_title')">
      <OrgNameForm
        :name="organization.name"
        :loading="loading"
        :errors="errors"
        @submit="(name) => emit('update-name', name)"
      />
    </OrgSettingsContent>
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;

.org-profile-settings {
  display: flex;
  flex-flow: column;
  gap: spacing.$s;
}
</style>
